import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailSelfServe = lazy(() =>
  import("@scenes/EmailSelfServe").then((module) => ({
    default: module.EmailSelfServe,
  }))
);

export const emailSelfServeNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) =>
    t("company-settings-email-self-serve-nro-heading", "Email Self Serve"),
  pageNameForTracking: () => "Email Self Serve",
  Component: EmailSelfServe,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    if (!featureOn("verified_domain")) {
      return false;
    }
    return (
      isImpersonating &&
      (hasPermission("company", { permission: "viewDomainSettings" }) ||
        hasPermission("company", { permission: "editDomainSettings" }))
    );
  },
  // NOTE: if you want to add an 'additionalSearchTerm', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchTerm' and follow the prompts
  additionalSearchTerms: () => [],
  // NOTE: when adding additionalSearchableFeatures make sure one of the
  // query params of the feature matches the key name of the feature.
  // NOTE 2: if you want to add an 'additionalSearchableFeature', please use the scaffold
  // via 'yarn scaffold' > 'nros' > 'additionalSearchableFeature' and follow the prompts
  additionalSearchableFeatures: () => ({}),
};
